import React from "react";
import TableList from "src/components/Admin/TableList/TableList";

export default function Account() {
  return (
    <>
      <div>
        <TableList Role="Account" />
      </div>
    </>
  );
}